// Configuration file for everything frontend related
// Copy right - © 2024 tecera gmbh
// TODO: add more information


export const DEBUG = false;
export const DOCKER = false;

// Definition of API Endpoints
export const BASE_API_URL = DOCKER ? "http://localhost/api" :(DEBUG ? "http://localhost:8000/api" : "https://ewe-mapview.2kai.eu/api")

// Regex
export const PASSWORD_REGEX = ".{8,}"; // Minimum 8 characters

export const ENABLE_LIVE_RELOADING = true;     // true
// Refresh intervall for devices in seconds -- NOT USED! TODO: Fix this triggering Device reactivity
export const DEVICE_REFRESH_INTERVALL_IN_SECONDS = 3600;    // Default: 3600

// Refresh intervall for alarms in seconds 
export const ALARM_REFRESH_INTERVALL_IN_SECONDS = 30;   // Default: 30

/**
 * Refresh intervall for data in seconds
 * Default: 30
 * @type {Number}
 */
export const DATA_REFRESH_INTERVALL_IN_SECONDS = 30;